import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function getTrialRejectedDevices() {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_trial_rejected_devices',
      })
    }
  );
};

export function getTrialRejectedDeviceById(id) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_trial_rejected_device_by_id',
        id: id,
      })
    }
  );
};

export function addTrialRejectedDevice(deviceId) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'add_trial_rejected_device',
        device_id: deviceId,
      })
    }
  );
};

export function editTrialRejectedDevice(id, isOn) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'edit_trial_rejected_device',
        id: id,
        is_on: isOn,
      })
    }
  );
};

export function getTrialRejectedDeviceHistory(deviceId) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_trial_rejected_device_history',
        trial_rejected_device_id: deviceId,
      })
    }
  )
}

export function getTrialRejectedDeviceHistoryById(id) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_trial_rejected_device_history_by_id',
        id: id,
      })
    }
  )
}



// WEBPACK FOOTER //
// ./src/services/trialRejectedDevices.js